import { INDUSTRIES } from "@/lib/constants";
import { Reveal } from "@/components/Reveal";

export default function Industries() {
  return (
    <section className="relative section-pad overflow-hidden" data-testid="industries-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-12 gap-6 mb-12">
          <div className="col-span-12 md:col-span-7">
            <div className="overline mb-4">06 · Industries</div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-[-0.02em] leading-[1]">
              Serving fourteen<br /><span className="italic">operating realities</span>.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 border-l border-t border-[color:var(--border)]">
          {INDUSTRIES.map((ind, i) => (
            <Reveal key={ind} delay={i * 0.03}>
              <div
                className="border-r border-b border-[color:var(--border)] p-6 md:p-8 min-h-[140px] flex items-end justify-between group cursor-default transition-colors hover:bg-[color:var(--surface-elev)]"
                data-testid={`industry-${ind.toLowerCase().replace(/\s+/g,'-')}`}
              >
                <span className="font-serif text-xl md:text-2xl tracking-tight leading-tight">{ind}</span>
                <span className="font-mono text-[10.5px] tracking-widest text-[color:var(--text-muted)]">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
